

import { jsPDF } from "jspdf";
// import { toBahtText } from "utils/toBahtText";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import dayjs from "dayjs";
import { printHeader } from "branch/functions/pirntHeader";
import { printTable } from "utils/printTable";

export const printFuelReportPeriod = ({ msData, dataTable, columns, dteSt, dteEn }) => {

  console.log("dataTable::", dataTable)

  const pageSize = [9.96, 14.04];
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: pageSize
  });
  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")
  const startY = 0.2
  const startX = 0.5
  let yPos = startY
  let xPos = startX
  //---------------------------------------------Start Print-----------------------------------------------------------


  const companyData = msData.serverData.CompanyData
  const lineHeight = 0.21
  const contentSize = 14
  let pageNo = 1

  doc.setFont("THSarabun")

  if (pageNo !== 1) {
    doc.addPage(pageSize, "portrait")
  }
  xPos = startX
  yPos = startY
  yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos })


  //----------------------------------------------- Top right data ------------------------------------------------
  yPos = startY + 0.2
  doc.setFont("THSarabun", "bold")
  doc.setFontSize(22)
  doc.text("รายงานการใช้น้ำมัน", 12, yPos, { align: "center" })

  doc.setFont("THSarabun", "bold")
  doc.setFontSize(contentSize)
  const lineHeightTopRight = lineHeight + lineHeight / 5
  const yPosTopRight = yPos + lineHeightTopRight
  const xPosTopRight = 11.7
  xPos = xPosTopRight
  yPos = yPosTopRight

  doc.text("วันที่ : ", xPos, yPos, { align: "right" })
  yPos += lineHeightTopRight
  doc.text("ถึง : ", xPos, yPos, { align: "right" })
  yPos += lineHeightTopRight
  doc.setFont("THSarabun", "normal")
  yPos = yPosTopRight
  xPos += 0.1
  doc.text(dayjs(dteSt).format("DD/MM/YYYY"), xPos, yPos)
  yPos += lineHeightTopRight
  doc.text(dayjs(dteEn).format("DD/MM/YYYY"), xPos, yPos)

  //----------------------------------------------- Draw Table ------------------------------------------------
  yPos += 0.2
  printTable({ doc, dataTable, columns, startX: startX - 0.2, startY: yPos, fontSize: 13, lineHeight: 0.20 })


  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  
  // Open in new tab
  window.open(blobUrl, '_blank');
  
  // Clean up memory after a small delay
  
;
}